import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=0d15b24a&scoped=true"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15b24a",
  null
  
)

export default component.exports